<template>
  <div id="delete-members-in-company">

    <memlist-modal ref="modal">
      
      <form @submit.prevent="submit_form">
        <m-row>
          <m-col lg="6">
            <memlist-select-input2
              v-model="company_id"
              :items="companies_options"
              :title="$t('COMPANY.NAME')"
              layout="vertical"
              size="sm"
              validation_type="TEXT"
            />
          </m-col>
          <m-col lg="6">
            <memlist-select-input2
              v-model="period_id"
              :items="period_options"
              :title="$t('PERIOD.NAME')"
              layout="vertical"
              size="sm"
              validation_type="TEXT"
            />
          </m-col>
        </m-row>


        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-text-input 
              v-model="confirm_str_generated" 
              type="text" 
              :title="$t('COMMON.CONFIRM_STRING_GENERATED')" 
              layout="vertical"
              size="sm"
              :disabled="true"
            />
          </m-col>
          <m-col lg="6">
            <memlist-text-input 
              v-model="confirm_str" 
              type="text" 
              :title="$t('COMMON.CONFIRM_STRING')" 
              layout="vertical"
              size="sm"
              :placeholder="$t('COMMON.CONFIRM_STRING')"
            />
          </m-col>
        </m-row>

        <m-row class="mt-4" v-if="invalid_confirm_str">
          <m-col lg="12">
            <p style="color: red;">{{ $t('COMMON.INVALID_CONFIRM_STR') }}</p>
          </m-col>
        </m-row>

        <m-row class="mt-4">
          <m-col lg="6">
            <memlist-button variant="secondary" @click="cancel_clicked">{{ $t('COMMON.CANCEL') }}</memlist-button>
          </m-col>
          <m-col lg="6">
            <memlist-spinner-button :override_spin="spinning" variant="danger" @click="confirm_clicked" :text="$t('COMMON.OK')">{{ $t('COMMON.OK') }}</memlist-spinner-button>
          </m-col>
        </m-row>

      </form>

    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { randomstr } from '@/core/services/deviceId';

export default {
  name: 'DeleteMembersInCompanyAndPeriodModal',
  components: {

  },
  mixins: [ toasts ],
  
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'periods']),
    companies_options() {
      let c = this.companies.sort((a,b) => {
        return (a.name || '').toUpperCase() < (b.name || '').toUpperCase();
      });

      return c.map(i => ({ text: i.name, value: i.company_id }));
    },
    period_options() {
      return this.periods.map(i => ({ text: i.name, value: i.id }));
    }
  },
  async mounted() {
    this.confirm_str_generated = randomstr(4).toUpperCase();
    this.period_id = this.currentPeriodId;
    this.company_id = this.currentCompanyId;
  },
  methods: {

    async confirm_clicked() {
      if (!this.period_id) {
        return;
      }
      if (!this.company_id) {
        return;
      }

      this.invalid_confirm_str = false;
      this.spinning = true;

      if (this.confirm_str_generated !== this.confirm_str) {
        this.invalid_confirm_str = true;
        return;
      }

      const res = await axios.delete(`/member/mucf/${this.period_id}/${this.company_id}`);

      if (res.status === 204) {
        this.spinning = false;

        this.toastr('success', this.$t('COMMON.OK'), this.$t('COMMON.DELETED'));
      }
      else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_DELETE'));
      }
    },
    cancel_clicked() {
      this.hide();
    },

    show() {
      this.$refs['modal'].show();
    },

    on_cancel() {
      this.$refs['modal'].hide();
    },


  },
  data() {
    return {
      spinning: false,
      company_id: null,
      period_id: null,
      confirm_str: null,
      confirm_str_generated: null,
      invalid_confirm_str: false,
    };
  },

};
</script>
<style lang="scss" scoped>

</style>
